// extracted by mini-css-extract-plugin
export default {"calender":"Calendar_calender__ObIbA","gitCalender":"Calendar_gitCalender__45nfy","stats":"Calendar_stats__q+wA0"};